import request from "../utils/request";
//获取壁纸管理列表
export function getWallpaperList(params) {
  return request({
    url: `/wallpaper/list?pageNum=${params.currentPage}&pageSize=${params.currentPageSize
      }&wallpaperName=${params.name}&wallpaperType=${params.type
      }&wallpaperStatus=${params.wallpaperStatus}&isAuth=${params.isAuth
      }&designerType=${params.designerType ? params.designerType : ""}&categoryId=${params.categoryId ? params.categoryId : ""}&authorId=${params.authorId}&dataSetId=${params.dataSetId}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}`,
    method: "get"
  });
}

//通过id查询壁纸详细信息
export function getWallpaperById(params) {
  return request({
    url: `/wallpaper/getWallpaperById?id=${params.id}`,
    method: "get"
  });
}

//根据Id删除wallpaper
export function deleteWallpaperById(params) {
  return request({
    url: `/wallpaper/deleteWallpaperById`,
    method: "post",
    data: {
      id: params.id
    }
  });
}

//切换上下线
export function onOrOff(params) {
  return request({
    url: `/wallpaper/onOrOff`,
    method: "post",
    data: {
      id: params.id
    }
  });
}

//编辑wallpaper
export function updateWallpaper(params) {
  return request({
    url: `/wallpaper/updateWallpaper`,
    method: "post",
    data: params
  });
}

//新增wallpaper
export function addWallpaper(params) {
  return request({
    url: `/wallpaper/addWallpaper`,
    method: "post",
    data: params
  });
}

//切换更新单张图片
export function resourcesUpdate(params) {
  return request({
    url: `/wallpaper/uploadSingleImage?name=${params.name}&url=${params.url}&key=${params.key}&type=${params.type}&userId=${params.userId}&index=${params.index}&resourceType=${params.resourceType}`,
    method: "post",
    data: params.file
  });
}

// 批量删除壁纸

export function batchDeleteWallpaper(params) {
  return request({
    url: `/wallpaper/deleteWallpaperByIds`,
    method: "post",
    data: params
  });
}